import React, { useState, useEffect } from "react";
import axios from "axios";
import Pdf from "../../editable-stuff/resume.pdf";
import {
  aboutHeading,
  aboutDescription,
  showInstaProfilePic,
  instaLink,
  instaUsername,
  instaQuerry,
} from "../../editable-stuff/configurations.json";

const Education = () => {
  const [instaProfilePic, setInstaProfilePic] = useState("");
  const [showInsta, setShowInsta] = useState(showInstaProfilePic);
  const [resumeURL] = useState(Pdf);

  useEffect(() => {
    if (showInsta) {
      handleRequest();
    }
  }, [showInsta]);

  const handleRequest = (e) => {
    axios
      .get(instaLink + instaUsername + instaQuerry)
      .then((response) => {
        // handle success
        // console.log(response.data.graphql);
        return setInstaProfilePic(
          response.data.graphql.user.profile_pic_url_hd
        );
      })
      .catch((error) => {
        // handle error
        setShowInsta(false);
        return console.error(error.message);
      })
      .finally(() => {
        // always executed
      });
  };

  return (
    <div id="education" className="jumbotron jumbotron-fluid m-0">
      <div className="container container-fluid p-5">
        <i class="fa fa-graduation-cap fa-5x" aria-hidden="true"></i>
        <h1 className="display-4 pb-5">Education</h1>
        <div className="row">
          <div class="col-sm-12">
            <div class="card">
              <h5 class="card-header">Master of Technology (M.Tech)</h5>
              <div class="card-body">
                <h5 class="card-title">2006-2008</h5>
                <p class="card-text">
                  Computer Science and Engineering, National Institute of
                  Technology, Bhopal
                </p>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div className="row">
          <div class="col-sm-12">
            <div class="card">
              <h5 class="card-header">Bachelor of Engineering (B.E.)</h5>
              <div class="card-body">
                <h5 class="card-title">2002-2006</h5>
                <p class="card-text">
                  Computer Science and Engineering, University of Technology,
                  Bhopal
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Education;
